module.exports = __webpack_public_path__ + "img/KFLogo.80b05f86.svg";